import { useScriptTag } from '@vueuse/core'

export const useLoadNagishli = async () => {
  const { load } = useScriptTag('nagishli/nagishli_beta.js', () => {}, {
    manual: true,
    async: true,
  })
  await load()
}

/**
 * Initialize Meta Pixel tracking code
 */
const initializeMetaPixel = () => {
  if (window.fbq) return // Already initialized

  window.fbq = function () {
    window.fbq.callMethod
      ? window.fbq.callMethod.apply(window.fbq, arguments)
      : window.fbq.queue.push(arguments)
  }

  if (!window._fbq) window._fbq = window.fbq
  window.fbq.push = window.fbq
  window.fbq.loaded = true
  window.fbq.version = '2.0'
  window.fbq.queue = []

  // Create and append the script element
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize Meta Pixel
  window.fbq('init', '671705102368420')

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=671705102368420&ev=PageView&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

/**
 * Track a Meta Pixel event
 * @param {Object} options - Tracking options
 * @param {string} options.eventType - Type of event to track ('PageView', 'AddPaymentInfo', 'Purchase', 'CompleteRegistration', 'InitiateCheckout')
 */
const trackMetaPixelEvent = (options = {}) => {
  if (!window.fbq) return

  const { eventType = 'PageView' } = options

  // Track the event type
  switch (eventType) {
    case 'PageView':
      window.fbq('track', 'PageView')
      break
    case 'AddPaymentInfo':
      window.fbq('track', 'AddPaymentInfo')
      break
    case 'Purchase':
      window.fbq('track', 'Purchase')
      break
    case 'CompleteRegistration':
      window.fbq('track', 'CompleteRegistration')
      break
    default:
      window.fbq('track', 'PageView')
  }
}

/**
 * Load Meta Pixel and track initial page view
 * @param {Object} options - Tracking options
 */
export const loadMetaPixel = async (options = {}) => {
  // Initialize Meta Pixel if not already done
  initializeMetaPixel()

  // Track initial event (usually PageView)
  trackMetaPixelEvent(options)
}

const useLoadScripts = () => {
  useLoadNagishli()
}
// Export the tracking function separately so it can be used anywhere without reinitializing
export const trackFBEvent = trackMetaPixelEvent

export default useLoadScripts
